import React from "react";
import logger from "logger";
import Backdrop from "./Backdrop";
export default function LoadingProgress() {
  return <Backdrop />;
}
